import {BrowserQRCodeReader, VideoInputDevice} from '@zxing/library';

function scanQrCode(videoId, callback, failCb) {
    var codeReader = new BrowserQRCodeReader();
    // getVideoInputDevices
    codeReader.listVideoInputDevices().then(videoInputDevices => {
        // console.log('视频输入设备:', videoInputDevices)//视频输入设备
        videoInputDevices.forEach(
            device => console.log(`${device.label}, ${device.deviceId}`)
        );
        codeReader.decodeFromInputVideoDevice(undefined, videoId)
            .then(result => {
                callback(result.text)
                codeReader.reset()
            })
            .catch(err => {
                failCb && failCb();
                console.error(err)
            });
    }).catch(err => {
        failCb && failCb();
        console.error(err)
    });
}

export {
    scanQrCode
}
